export default {
  gameSummary: {
    sections: {
      matchupInformation: "Informações do matchup",
      rankings: "Rankings",
    },
    labels: {
      record: "Registro",
      rank: "Ranking",
      type: "Tipo",
      stat: "Stat",
      filterByGame: "Filtrar por jogo",
      position: "Posição",
      injury: "Lesão",
      status: "Status",
      trend: "Tendência",
    },
    standingTypes: {
      division: "Divisão",
      conference: "Conferência",
      league: "Liga",
      overall: "Geral",
    },
    rankingSides: {
      FOR: "A FAVOR",
      AGAINST: "CONTRA",
    },
    statAbbreviations: {
      PTS: "PTS",
      "SCORE %": "SCORE %",
      "SCORE%": "SCORE%",
      PLAYS: "JOGADAS",
      "NET YDS": "NET YDS",
      "PASS YDS": "PASS YDS",
      "PASS ATT": "TENT. PASSE",
      "PASS COMPL": "PASSES COMP.",
      "PASS TD": "PASS TD",
      "RUSH YDS": "RUSH YDS",
      "RUSH ATT": "TENT. CORRIDA",
      "RUSH TD": "RUSH TD",
      "TOTAL TDS": "TOTAL TDS",
      "RZ%": "RZ%",
      "1D": "1D",
      "3D%": "3D%",
      "4D%": "4D%",
      INT: "INT",
      TO: "TO",
      SACKS: "SACKS",
      FUML: "FUML",
      G: "GOLS",
      SOG: "SOG",
      SAT: "SAT",
      "CF%": "CF%",
      "PP%": "PP%",
      PIM: "PIM",
      PPG: "PPG",
      SHG: "SHG",
      "SH%": "SH%",
      BLK: "BLK",
      FTM: "FTM",
      FTA: "FTA",
      "FT%": "FT%",
      FGM: "FGM",
      FGA: "FGA",
      "FG%": "FG%",
      "3PTM": "3PTM",
      "3PTA": "3PTA",
      "3PT%": "3PT%",
      "TS%": "TS%",
      "eFG%": "eFG%",
      TRB: "REB",
      AST: "AST",
      STL: "STL",
      R: "R",
      H: "H",
      "1B": "1B",
      "2B": "2B",
      "3B": "3B",
      TB: "TB",
      ER: "ER",
      HR: "HR",
      RBI: "RBI",
      BB: "BB",
      SO: "SO",
      E: "E",
      AVG: "AVG",
      OBP: "OBP",
      SLG: "SLG",
      OPS: "OPS",
      POS: "POS",
      SHO: "CHUTES",
      SOT: "SOT",
      COR: "ESC",
      OFF: "IMP",
      FLS: "FALTAS",
      "2YELRED": "2YELRED",
      YEL: "AMARELO",
      RED: "VERMELHO",
      T: "E",
      "CR%": "CR%",
      RM: "RM",
      LB: "LB",
      K: "K",
      KM: "KM",
    },
    quickPicks: {
      moneyline: "Moneyline",
      spread: "Spread",
      total: "Total",
    },
  },
};
